<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (custom)="onCopy($event)" (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="params" [dataProvider]="compositionService" [title]="'Compositions'" icon="content_copy">
  </data-table>
</page-content>

<mat-card appearance="outlined" *ngIf="!!deadCompositions && deadCompositions.length > 0">
  <mat-card-title>Compositions without 'typeId'</mat-card-title>
  <mat-list>

    <mat-list-item *ngFor="let entry of deadCompositions">
      {{entry.title}}
      <button (click)="removeDeadComposition(entry._id)" mat-raised-button style="position:absolute; right:0">remove</button>
    </mat-list-item>
  </mat-list>
</mat-card>


